import { ds } from 'mewe/stores/ds';
import fetchEvents from 'mewe/fetchers/fetch-events';
import { fetchEventsCounters, getCounters } from 'mewe/fetchers/fetch-events-counters';
import { Theme } from 'mewe/constants';

import Route from 'mewe/routes/route';

export default Route.extend({
  theme: Theme.EVENTS,

  activate: function () {
    this._super();
    window.scrollTo(0, 0);
  },

  model: function () {
    return {
      upcoming: ds.events.for('upcoming-events'),
      invited: ds.events.for('invited-events'),
      counters: getCounters('events'),
      theme: this.get('theme'),
    };
  },

  activate: function () {
    this._super();

    fetchEvents('events', 'upcoming-events');
    fetchEvents('events', 'invited-events');
    fetchEventsCounters('events');
  },
});
